import { Controller, useFormContext } from 'react-hook-form';

import { FormInput, FormLabel, FormRow } from '@ui/components/Form/Form';
import { Tabs } from '@ui/components/Tabs';

import { TournamentEditFormValues } from '@features/tournament/ui/components/TournamentSettings';

const TABS = [
  { value: 1, label: '1' },
  { value: 2, label: '2' },
];

export function RoundRobinRoundsCount() {
  const { control } = useFormContext<TournamentEditFormValues>();
  return (
    <FormRow>
      <FormLabel>Количество кругов</FormLabel>
      <FormInput>
        <Controller
          name="roundRobinSettings.roundsCount"
          control={control}
          render={({ field: { value, onChange, disabled } }) => (
            <Tabs tabs={TABS} value={value} onChange={onChange} disabled={disabled} />
          )}
        />
      </FormInput>
    </FormRow>
  );
}
